import {
  Flipcard,
  FlipcardButton,
  FlipcardButtonProps,
  FlipcardContent,
} from '@/components/flipcard';
import { useTranslation } from '@/hooks/use-translation';
import { FlashcardFlipCardProps } from './types';
import { memoClassNames } from '@/utils';

export type FlashcardViewProps = FlashcardFlipCardProps & {
  slots?: {
    FlipButton?: React.ElementType<FlipcardButtonProps>;
  };
};

const classes = memoClassNames('FlashcardView', ['root']);
export function FlashcardView({
  data,
  displaySide,
  preventFlipBack,
  onFlip = () => {},
  slots = {},
  disabled,
  className = '',
}: FlashcardViewProps) {
  const { t } = useTranslation();
  const { FlipButton = FlipcardButton } = slots;

  const flipped = displaySide === 'back';

  const frontContent = (
    <FlipcardContent className="mm:flex mm:flex-col mm:gap-6 mm:items-center">
      <p className="mm:text-xl">{data.front}</p>
      <FlipButton
        disabled={disabled}
        variant="ghost"
        label={t('flashcardFlip', 'Mostra risposta')}
        onClick={() => {
          onFlip();
        }}
      />
    </FlipcardContent>
  );

  const backContent = (
    <FlipcardContent className="mm:flex mm:flex-col mm:gap-6 mm:items-center">
      <div>
        {preventFlipBack ? (
          <p className="mm:text-muted mm:text-sm mm:mb-2">{data.front}</p>
        ) : null}
        <p className="mm:text-xl">{data.back}</p>
      </div>
      {!preventFlipBack && (
        <FlipButton
          disabled={disabled}
          variant="ghost"
          flipped
          label={t('flashcardFlipBack', 'Mostra domanda ')}
          onClick={() => {
            onFlip();
          }}
        />
      )}
    </FlipcardContent>
  );

  return (
    <Flipcard
      back={backContent}
      className={`${classes.root} ${className}`}
      flip={flipped}
      front={frontContent}
    />
  );
}

FlashcardView.displayName = 'FlashcardView';
